import { lazy } from 'react';

import { routes } from '@/shared/lib';

const MeetingGroupById = lazy(() => import('./meeting-group-by-id'));
// const ServersPage = lazy(() => import('./workspace-page'));
// const ServersSessionsPage = lazy(() => import('./workspace-conversation-page'));
const ConversationPage = lazy(() => import('./conversation-page'));
// const DiscordVoicePage = lazy(() => import('./discord-voice-page'));
const MeetingGroupsPage = lazy(() => import('./meeting-groups-page'));

export const publicRoutes = [];

export const privateRoutes = [
  {
    path: routes.MAIN,
    Component: <MeetingGroupsPage />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById`,
    Component: <MeetingGroupById />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById${routes.SERVERS}/:guildId${routes.SESSIONS}/:sessionId`,
    Component: <ConversationPage />,
  },
  {
    path: `${routes.MEETING_GROUP}/:meetingGroupById${routes.SERVERS}/:guildId${routes.SESSIONS}/:sessionId/live`,
    Component: <ConversationPage isLive />,
  },
];
